//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('selectShift', {
//        templateUrl: 'views/components/views/selectShift/selectShift.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'selectShiftService', function ($stateParams, stateService, selectShiftService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let labourNo = $stateParams.labour_no;

//            vm.model = {
//                itemsListWorkShifts: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadWorkShifts() {
//                vm.model.itemsListWorkShifts = await selectShiftService.listWorkShifts({ labour_no: labourNo });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region SAVE TO PREVIOUS PROCEDURE FUNCTION CALL

//            vm.goBackToPrevious = function (item) {
//                selectShiftService.saveToPrevious({
//                    shift_id: item.item_id,
//                    labour_no: labourNo
//                });
//            }

//            // #endregion SAVE TO PREVIOUS PROCEDURE FUNCTION CALL

//            // #region BUTTON CANCEL TO PREVIOUS

//            vm.cancelToPrevious = function () {
//                stateService.back();
//            }

//            // #endregion BUTTON CANCEL TO PREVIOUS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                loadWorkShifts();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
